(function () {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('DocumentDeleteSelectedController', DocumentDeleteSelectedController);

    DocumentDeleteSelectedController.$inject = ['$uibModalInstance', 'documentIds', 'Document'];

    function DocumentDeleteSelectedController($uibModalInstance, documentIds, Document) {
        var vm = this;

        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        vm.externalRecipients = [];
        vm.recipientsCheckFailed = false;
        vm.recipientsLoading = false;

        // Deleting these documents also deletes their external access hashes, so any link
        // already emailed stops working for good. Warn about the recipients that hold one.
        // Fails CLOSED - see document-delete-dialog.controller.js for why.
        if (documentIds && documentIds.length > 0) {
            vm.recipientsLoading = true;
            Document.externalAccessRecipients(
                { ids: documentIds },
                function (result) {
                    if (result && angular.isArray(result.emails)) {
                        vm.externalRecipients = result.emails;
                    } else {
                        vm.recipientsCheckFailed = true;
                    }
                    vm.recipientsLoading = false;
                },
                function () {
                    vm.recipientsCheckFailed = true;
                    vm.recipientsLoading = false;
                }
            );
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete() {
            $uibModalInstance.close(true);
        }
    }
})();
